import { render, staticRenderFns } from "./SiteSummary.vue?vue&type=template&id=6419b695&"
import script from "./SiteSummary.vue?vue&type=script&lang=js&"
export * from "./SiteSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6419b695')) {
      api.createRecord('6419b695', component.options)
    } else {
      api.reload('6419b695', component.options)
    }
    module.hot.accept("./SiteSummary.vue?vue&type=template&id=6419b695&", function () {
      api.rerender('6419b695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sitepopup/SiteSummary.vue"
export default component.exports